import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import MUIDataTable from "mui-datatables";

const styles = theme => ({});

class MessagesTable extends React.Component {
	constructor() {
		super();
		this.state = {};
	}

	render() {
		const { data, onRowDeleted } = this.props;
		const columns = ["Time", "Name", "Email", "Message"];
		const options = {
			filter: true,
			responsive: "scroll",
			selectableRows: true,
			onRowsDelete: rowsDeleted => onRowDeleted(rowsDeleted, data)
		};
		return (
			<MUIDataTable
				title={"Messages"}
				data={data}
				columns={columns}
				options={options}
			/>
		);
	}
}

export default withStyles(styles)(MessagesTable);
